import { formatDateLL } from "../../../algorithms";
import { paths } from "../../../paths/paths";

const PostCommentsCard = ({ comment, index, length }) => {
  return (
    <div className="p-3 mt-2" style={{}}>
      <div
        id={comment.id}
        className="d-flex justify-content-between w-100"
        style={{}}
      >
        <div className="d-flex align-items-center justify-content-start  col-md-8 ">
          <div
            style={{
              backgroundImage: `url("${paths.MemberPhoto}${comment.memberId}/${comment.memberPhoto}")`,
              width: 40,
              height: 40,
              borderRadius: "50%",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              border: "1px solid white",
            }}
          ></div>
          <p className="my-0 px-2" style={{ fontWeight: "bold" }}>
            {comment.memberName}
          </p>
        </div>
        <div className="d-flex align-items-center justify-content-center col-4">
          <div className="d-flex mb-2">
            <span className="text-muted" style={{ fontSize: 14 }}>
              {formatDateLL(comment.createDate)}
            </span>
          </div>
        </div>
      </div>

      <div className="d-flex  flex-column flex-md-row px-5 align-items-md-center align-items-start justify-content-between">
        <div
          className="col-md-9 col-12"
          style={{
            textAlign: "justify",
            fontSize: 16,
            color: "#444444",
          }}
        >
          {comment.description}
        </div>
      </div>

      {index != length ? <hr className="my-3" /> : null}
    </div>
  );
};

export default PostCommentsCard;
